<template>
  <div
    class="ui-chip-group c-sport-filter"
    role="group"
    aria-labelledby="sport-filter-label"
  >
    <span
      id="sport-filter-label"
      class="c-sport-filter__label"
    >Sport</span>
    <button
      v-for="sport in visibleSports"
      :id="sport.id"
      :key="sport.id"
      type="button"
      :class="['ui-chip', { 'ui-chip--active': sport.id === activeId }]"
      :aria-pressed="String(sport.id === activeId)"
      @click="$emit('change', sport)"
    >
      {{ sport.name }}
    </button>

    <button
      v-if="hiddenCount > 0 || expanded"
      type="button"
      class="ui-chip c-sport-filter__toggle"
      :aria-expanded="String(expanded)"
      @click="expanded = !expanded"
    >
      {{ expanded ? 'Show less' : `+${hiddenCount} more` }}
    </button>
  </div>
</template>

<script>
// Sport chips; long lists collapse to the first `limit` sports (plus the active one).
export default {
  name: 'SportFilter',
  props: {
    sports: {
      type: Array,
      required: true,
    },
    activeId: {
      type: [Number, String],
      default: null,
    },
    limit: {
      type: Number,
      default: 16,
    },
  },
  data: () => ({
    expanded: false,
  }),
  computed: {
    visibleSports() {
      if (this.expanded || this.sports.length <= this.limit) {
        return this.sports;
      }

      const visible = this.sports.slice(0, this.limit);
      const active = this.sports.find(sport => sport.id === this.activeId);

      return active && !visible.includes(active) ? [...visible, active] : visible;
    },

    hiddenCount() {
      return this.sports.length - this.visibleSports.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.c-sport-filter {
  align-items: center;
}

.c-sport-filter__label {
  margin-right: 4px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
}

.c-sport-filter__toggle {
  border-style: dashed;
  color: var(--text-primary);
}
</style>
